import { render, staticRenderFns } from "./SwitchSessionBar.vue?vue&type=template&id=f3e86140&scoped=true"
import script from "./SwitchSessionBar.vue?vue&type=script&lang=js"
export * from "./SwitchSessionBar.vue?vue&type=script&lang=js"
import style0 from "./SwitchSessionBar.vue?vue&type=style&index=0&id=f3e86140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e86140",
  null
  
)

export default component.exports